import { FormattedMessage } from 'react-intl';

const NoData = () => (
    <span className={'text-color-gray'}>
        <FormattedMessage id={'intl-msg:maintenanceHistory.noData'} />
    </span>
);

export default NoData;
